<template lang="pug">
.v-gallery.gallery
	v-modal-window.modal-window--gallery
		template(v-if="items && items.length")
			.gallery__slider
				v-image-slider(:data-source="{'items': items}" mode="gallery" :initial-index="initialIndex")
</template>

<script>
import sourceMixin from '../components/mixins/v-mixin-source.vue';

export default {
	mixins: [
		sourceMixin
	],

	props: {
		initialIndex: {
			type: Number,
			default: 0
		}
	},

	data() {
		return {
			items: null
		};
	},

	methods: {
		dataSet(data) {
			this.items = data.items;
		}
	}
};
</script>